module.exports = __webpack_public_path__ + "c21cf11a6485c71ac3f5c1515780bfd9.svg";